// App.js
import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { CssBaseline, Box, createTheme, ThemeProvider } from "@mui/material";

// IMPORTANT: wrap your app in DndProvider with an appropriate backend
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

// Your existing imports
import Sidebar from "./scenes/global/Sidebar";
import Topbar from "./scenes/global/Topbar";
import AIWrapper from "./scenes/ai-pagewrapper/index";
import PageConfig from "./scenes/pageconfig/index";
import AIResponseDashboard from "./scenes/dashboard-ai-response/index";
import MealViewerConfigurator from "./scenes/mealviewer_configurator/index";
import AImenu from "./scenes/ai-menu/index";
import Dashboard from "./scenes/dashboard/index";
import FloatingWindowModal from "./scenes/global/FloatingWindowModal";
import Sandbox from "./scenes/sandbox/index";
import SailCanvas from '../src/scenes/sail-partnerhub';
import BulkInvoice from '../src/scenes/bulk-invoice'
// 1) Import your Kanban component
import KanbanBoard from "./components/Boards/kanban";
import FBG from '../src/scenes/usda-fbg';

// 2) Import your USDA CNDB scene
import USDAFoodSearch from "./scenes/usda-cndb/index";

// 3) Import new scenes
import USDAFDC from "./scenes/usda-fdc/index";
import GDSNProducts from "./scenes/gdsn-products/index";

const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#005FCC",
        },
        background: {
            default: "#f4f6f8",
        },
    },
});

function App() {
    const [isSidebar, setIsSidebar] = useState(true);

    return (
        <ThemeProvider theme={theme}>
            {/* Provide the React DnD context to the entire app */}
            <DndProvider backend={HTML5Backend}>
                <CssBaseline />
                <Box
                    sx={{
                        display: "flex",
                        height: "100vh",
                        width: "100vw",
                        overflow: "hidden",
                    }}
                >
                    <Routes>
                        {/* Redirect root path to Sandbox as the default page */}
                        <Route path="/" element={<Navigate to="/sandbox" />} />

                        {/* AI Wrapper Page without Sidebar and Topbar */}
                        <Route path="/ai-pagewrapper" element={<AIWrapper />} />

                        {/* AI Menu Page without Sidebar and Topbar */}
                        <Route path="/ai-menu" element={<AImenu />} />

                        {/* Main layout for everything else */}
                        <Route
                            path="/*"
                            element={
                                <Box sx={{ display: "flex", height: "100vh", width: "100vw" }}>
                                    <Sidebar isSidebar={isSidebar} />
                                    <Box
                                        sx={{
                                            flex: 1,
                                            overflowY: "auto",
                                            padding: "20px",
                                        }}
                                    >
                                        {/* Nested routes */}
                                        <Routes>
                                            <Route path="/mealviewer_configurator" element={<MealViewerConfigurator />} />
                                            <Route path="/pageconfig" element={<PageConfig />} />
                                            <Route path="/ai-response-dashboard" element={<AIResponseDashboard />} />
                                            <Route path="/sandbox" element={<Sandbox />} />
                                            <Route path="/dashboard" element={<Dashboard />} />
                                            <Route path="/floating-window-modal" element={<FloatingWindowModal />} />

                                            {/* Route for your Kanban component */}
                                            <Route path="/kanban" element={<KanbanBoard />} />

                                            {/* Route for USDA CNDB scene */}
                                            <Route path="/usda-cndb" element={<USDAFoodSearch />} />

                                            {/* New routes */}
                                            <Route path="/usda-fdc" element={<USDAFDC />} />
                                            <Route path="/usda-fbg" element={<FBG />} />
                                            <Route path="/gdsn-products" element={<GDSNProducts />} />
                                            <Route path="/sail-partnerhub" element={<SailCanvas />} />
                                            <Route path="/bulk-invoice" element={<BulkInvoice />} />
                                        </Routes>
                                    </Box>
                                </Box>
                            }
                        />
                    </Routes>
                </Box>
            </DndProvider>
        </ThemeProvider>
    );
}

export default App;
